export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'ko',
  fallbackLocale: 'ko',
}))
